/** The route planner page. */
export default {
  'Route planner': 'Planifikuesi i udhëtimeve',
  'Saved. The planner applies it within a minute.': 'U ruajt. Planifikuesi e zbaton brenda një minute.',
  'How trips are planned in the app, what the planner has loaded, and what people ask it.':
    'Si planifikohen udhëtimet në aplikacion, çfarë ka ngarkuar planifikuesi dhe çfarë kërkojnë njerëzit.',
  'Planner not reachable': 'Planifikuesi nuk arrihet',
  'Turned off': 'I fikur',
  'Loading data…': 'Po ngarkohen të dhënat…',
  'Running · walking network loading': 'Në punë · rrjeti i këmbësorëve po ngarkohet',
  'Use in the app': 'Përdorimi në aplikacion',
  'Trips planned': 'Udhëtime të planifikuara',
  '{n} per day': '{n} në ditë',
  'No way found': 'Asnjë rrugë e gjetur',
  '{n} trips · {f} failed': '{n} udhëtime · {f} dështuan',
  'Fastest way, on average': 'Rruga më e shpejtë, mesatarisht',
  'answered in {n} ms on average': 'përgjigje për {n} ms mesatarisht',
  'Place searches': 'Kërkime vendesh',
  '{p} found nothing': '{p} pa rezultat',

  // Settings
  Settings: 'Cilësimet',
  'Longest walk between stations': 'Ecja më e gjatë mes stacioneve',
  'When changing buses, walked along the streets.': 'Kur ndërrohet autobusi, e matur nëpër rrugë.',
  'Time to change buses': 'Koha për ndërrim autobusi',
  'On top of the walk: the next bus must leave at least this much later.':
    'Mbi ecjen: autobusi tjetër duhet të niset të paktën kaq më vonë.',
  'Most changes in a trip': 'Më së shumti ndërrime në një udhëtim',
  '0: direct buses only. At most 3.': '0: vetëm autobusë direkt. Më së shumti 3.',
  'Longest walk to the first stop': 'Ecja më e gjatë deri te stacioni i parë',
  'And from the last stop. With no stop that close, the 3 nearest within 2 km.':
    'Dhe nga stacioni i fundit. Nëse asnjë stacion s’është aq afër, 3 më të afërtit brenda 2 km.',
  'Walking alone, always offered up to': 'Vetëm në këmbë, ofrohet gjithmonë deri në',
  'Shown next to the buses, even when a bus is faster.':
    'Shfaqet pranë autobusëve, edhe kur autobusi është më i shpejtë.',
  'Walking alone, never beyond': 'Vetëm në këmbë, kurrë përtej',
  'Between the two, walking is offered only when no bus is faster.':
    'Mes të dyjave, ecja ofrohet vetëm kur asnjë autobus s’është më i shpejtë.',
  'Walking speed': 'Shpejtësia e ecjes',
  '4.5 km/h is a usual pace; the app shows walking times with it.':
    '4.5 km/h është ritëm i zakonshëm; aplikacioni i tregon kohët e ecjes me të.',
  'How much walking is avoided': 'Sa shmanget ecja',
  'Walking minutes count this many times when ways are compared. 1: walking is as good as riding.':
    'Minutat e ecjes llogariten kaq herë kur krahasohen rrugët. 1: ecja vlen sa udhëtimi me autobus.',
  'Changed {time}': 'Ndryshuar {time}',
  'Trip planning in the app': 'Planifikimi i udhëtimeve në aplikacion',
  'Count the trips asked for': 'Numëro udhëtimet e kërkuara',
  'Off: the app says trip planning is not available right now. Place search still works.':
    'I fikur: aplikacioni thotë se planifikimi s’është i disponueshëm tani. Kërkimi i vendeve punon.',
  'Default: {v}': 'Parazgjedhur: {v}',
  'Only rounded places (≈ 100 m) and counts are kept: per hour, per area for 90 days, and the last 1000 trips. Nothing that identifies a phone or a person.':
    'Ruhen vetëm vende të rrumbullakuara (≈ 100 m) dhe numra: për orë, për zonë për 90 ditë, dhe 1000 udhëtimet e fundit. Asgjë që identifikon një telefon apo person.',
  'Back to defaults': 'Kthe parazgjedhjet',
  'Cannot be more than the longest walk': 'Nuk mund të jetë më shumë se ecja më e gjatë',
  'The planner is not configured': 'Planifikuesi nuk është konfiguruar',
  'The planner is not available (off, loading or down)':
    'Planifikuesi s’është i disponueshëm (i fikur, po ngarkohet ose jashtë funksionit)',

  // Status
  'What the planner has loaded': 'Çfarë ka ngarkuar planifikuesi',
  'The planner service cannot be reached. The app shows that trip planning is not available.':
    'Shërbimi i planifikuesit nuk arrihet. Aplikacioni tregon se planifikimi s’është i disponueshëm.',
  'Running since': 'Në punë që nga',
  'Network and timetables read': 'Rrjeti dhe oraret u lexuan',
  '{n} ms': '{n} ms',
  'Read again': 'Lexohen sërish',
  'Lines · directions · stations': 'Linja · drejtime · stacione',
  'Directions with a timetable': 'Drejtime me orar',
  '{w} weekdays · {e} weekend': '{w} ditë pune · {e} fundjavë',
  'Bus trips per day': 'Udhëtime autobusi në ditë',
  '{wd} weekday · {sat} Sat · {sun} Sun': '{wd} ditë pune · {sat} e shtunë · {sun} e diel',
  'Times between stops, measured': 'Kohët mes stacioneve, të matura',
  'Walking network (OpenStreetMap)': 'Rrjeti i këmbësorëve (OpenStreetMap)',
  'Loading… walks are estimated until then': 'Po ngarkohet… deri atëherë ecjet vlerësohen',
  'Walking changes between stations': 'Ndërrime në këmbë mes stacioneve',
  '{n} pair': '{n} çift',
  '{n} pairs': '{n} çifte',
  'along the streets': 'nëpër rrugë',
  estimated: 'të vlerësuara',
  'Places to search': 'Vende për kërkim',
  'OSM {time}': 'OSM {time}',
  'Answers since start': 'Përgjigje që nga nisja',
  '{n} · usually {p50} ms, slow {p95} ms': '{n} · zakonisht {p50} ms, të ngadalta {p95} ms',
  Memory: 'Memoria',
  'Settings read': 'Cilësimet u lexuan',

  // Checks
  'What the planner cannot use': 'Çfarë nuk mund të përdorë planifikuesi',
  'Shown once the planner has loaded.': 'Shfaqet pasi planifikuesi të ketë ngarkuar.',
  '{n} direction without departures': '{n} drejtim pa nisje',
  '{n} directions without departures': '{n} drejtime pa nisje',
  'No first-stop times in the timetable: no trips are planned on them on those days.':
    'Pa orare nisjeje nga stacioni i parë: atyre ditëve nuk planifikohen udhëtime me to.',
  weekdays: 'ditë pune',
  weekend: 'fundjavë',
  '{n} station no bus stops at': '{n} stacion ku s’ndalon asnjë autobus',
  '{n} stations no bus stops at': '{n} stacione ku s’ndalon asnjë autobus',
  'Not on any direction that has departures.': 'Nuk është në asnjë drejtim që ka nisje.',
  '{n} station away from the streets': '{n} stacion larg rrugëve',
  '{n} stations away from the streets': '{n} stacione larg rrugëve',
  'More than 150 m from any walkable street in OpenStreetMap: walks to them are straight lines. Check the position.':
    'Më shumë se 150 m nga çdo rrugë për këmbësorë në OpenStreetMap: ecjet deri te to janë vija të drejta. Kontrolloni pozitën.',
  None: 'Asnjë',

  // Storage
  'Stored for the planner': 'Të ruajtura për planifikuesin',
  'Places from OpenStreetMap': 'Vende nga OpenStreetMap',
  'Measured times between stops': 'Kohë të matura mes stacioneve',
  'Trips per hour (kept 2 years)': 'Udhëtime për orë (ruhen 2 vjet)',
  'Trips per area and day (kept 90 days)': 'Udhëtime për zonë dhe ditë (ruhen 90 ditë)',
  'Searches with no result (kept 90 days)': 'Kërkime pa rezultat (ruhen 90 ditë)',
  'Last trips (the last 1000)': 'Udhëtimet e fundit (1000 të fundit)',
  'OpenStreetMap places read {time}; read again every week. The walking network stays in the planner’s memory.':
    'Vendet nga OpenStreetMap u lexuan {time}; lexohen sërish çdo javë. Rrjeti i këmbësorëve mbahet në memorien e planifikuesit.',
  'OpenStreetMap places are read soon after the planner starts.':
    'Vendet nga OpenStreetMap lexohen pak pasi niset planifikuesi.',

  // Use in the app
  'Trips planned per day': 'Udhëtime të planifikuara në ditë',
  'The fastest way found': 'Rruga më e shpejtë e gjetur',
  'Direct bus': 'Autobus direkt',
  'One change': 'Një ndërrim',
  'Two changes or more': 'Dy ndërrime ose më shumë',
  Walking: 'Në këmbë',
  'First bus live (on its way)': 'Autobusi i parë live (në rrugë)',
  'Arrive by a time': 'Mbërritje deri në një orë',
  'For later': 'Për më vonë',
  'When trips are planned (hour of day)': 'Kur planifikohen udhëtimet (ora e ditës)',
  '{h}:00 · {n} trips · {s} searches': '{h}:00 · {n} udhëtime · {s} kërkime',
  'Where trips start and end': 'Ku nisin dhe ku mbarojnë udhëtimet',
  To: 'Deri',
  'Most planned trips': 'Udhëtimet më të planifikuara',
  'Where no way is found': 'Ku nuk gjendet rrugë',
  'Searched for, found nothing': 'U kërkua, s’u gjet asgjë',
  'What people look for that the search does not know: add it as a point of interest, or fix the name in OpenStreetMap.':
    'Çfarë kërkojnë njerëzit që kërkimi nuk e njeh: shtojeni si pikë interesi, ose rregulloni emrin në OpenStreetMap.',
  'Last trips asked for': 'Udhëtimet e fundit të kërkuara',
  'Only with no way found': 'Vetëm pa rrugë të gjetur',
  'Fastest way': 'Rruga më e shpejtë',
  Answer: 'Përgjigja',
  'arrive by': 'mbërritje deri',
  'for {time}': 'për {time}',
  failed: 'dështoi',
  'no way found': 'asnjë rrugë',
  walking: 'në këmbë',
  'Try again': 'Provo sërish',

  // Try a trip
  'Could not plan': 'Nuk u planifikua dot',
  'Try a trip': 'Provo një udhëtim',
  'Click the map where the trip starts.': 'Klikoni në hartë ku niset udhëtimi.',
  'Now click where it ends.': 'Tani klikoni ku mbaron.',
  'Leaving now. Click the map again to start over.':
    'Me nisje tani. Klikoni sërish në hartë për të filluar nga e para.',
  'Planning…': 'Po planifikohet…',
  'No way found. Is a stop within the walking distance of both places, and does a bus run now?':
    'Asnjë rrugë e gjetur. A ka stacion brenda distancës së ecjes nga të dy vendet, dhe a qarkullon autobus tani?',
  '{n} change': '{n} ndërrim',
  '{n} changes': '{n} ndërrime',
  '{n} m walking': '{n} m në këmbë',
  'Answered in {n} ms. * walk estimated (no street path).':
    'Përgjigje për {n} ms. * ecje e vlerësuar (pa rrugë të njohur).',

  // Tabs
  Overview: 'Përmbledhje',
  Trips: 'Udhëtimet',
  'Last {n} days in the app': '{n} ditët e fundit në aplikacion',
  'More about use': 'Më shumë për përdorimin',

  // Arrivals at stations (mobile app page)
  'Arrivals at stations': 'Mbërritjet në stacione',
  'Show departures from the timetable when no bus is on its way':
    'Shfaq nisjet sipas orarit kur asnjë autobus nuk është në rrugë',
  'Marked “scheduled” in the list, between the live buses by time.':
    'Shënohen “sipas orarit” në listë, mes autobusëve live sipas kohës.',
  'Off: a station lists live buses only; with none on its way it says no line is expected soon.':
    'I fikur: stacioni tregon vetëm autobusët live; kur asnjë s’është në rrugë, thotë se asnjë linjë nuk pritet së shpejti.',
  'How far ahead': 'Sa përpara',
  'Departures later than this are not listed.': 'Nisjet më vonë se kaq nuk listohen.',
  'Per direction': 'Për drejtim',
  'How many departures of each direction.': 'Sa nisje për secilin drejtim.',
  'Applies to the new app within 30 seconds, no update needed. Trip planning still uses the timetable.':
    'Zbatohet në aplikacionin e ri brenda 30 sekondave, pa përditësim. Planifikimi i udhëtimeve vazhdon të përdorë orarin.',
};
